import { mapValues } from 'es-toolkit';
import { createSelector } from '@reduxjs/toolkit';

import { RootState } from '../slices';

export const getDoWorkingChangesExistByLoadedComponentDesignGuid = createSelector(
  (state: RootState) => state.componentDesignTimestamps,

  (componentDesignTimestamps) =>
    mapValues(componentDesignTimestamps, (timestamps) => {
      if (!timestamps) return true;
      const { lastAnalyzed, lastUpdated } = timestamps;
      const notAnalyzed = lastAnalyzed === null;
      if (notAnalyzed) return true;
      const areWorkingChanges = new Date(lastUpdated) > new Date(lastAnalyzed);
      return areWorkingChanges;
    }),
);
